import FundAttachments from './FundAttachments'

export default FundAttachments
